import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material';

import { AppComponent } from './app.component';
import { TreatmentReminderComponent } from './treatmentreminder/treatmentreminder.component';
import { Variables } from './variables';
import { LoginComponent } from './login/login.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        TreatmentReminderComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        MatProgressSpinnerModule,
        FormsModule,
        RouterModule.forRoot([
            { path: "", component: LoginComponent },
            { path: "r", component: TreatmentReminderComponent },
        ])
    ],
    providers: [Variables],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts